// extracted by mini-css-extract-plugin
export default {"form":"UserForm_form__Om1Bo","btn":"UserForm_btn__UGdGC","text":"UserForm_text__zWLl5","input":"UserForm_input__G7QH3"};